
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Sample } from '../../components';

@Component({
    selector: 'app-containers',
    imports: [Sample],
    templateUrl: './containers.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './containers.scss'
})
export class Containers {}
